module.exports = __webpack_public_path__ + "img/example-2.828c19de.png";